import React from 'react';

import { CtaButton, ModeLogo, SelectedCategories, TeamCard } from '../';

export const RoundIntro = ({ game, currentRoundIndex, roundsCount, totalTaskCount, setRoundStarted}) => {

  const screenText = game.screenText;

  if (!screenText || !screenText.play || !screenText.play.intro) {
    return "Missing text";
  }

  const { intro : introText } = screenText.play;

  const getDescriptionText = () => {

    const roundText = introText.description[game.mode][currentRoundIndex];
    let descText = typeof roundText === "string" ? roundText : roundText[game.role];

    return descText.replace('#', totalTaskCount / game.teams.length);

  }

  return (
    <div className="round-intro">

      <header className="round-intro__logo">
        <ModeLogo mode={game.mode} />
        <div className="dotted-line"></div>
      </header> 
      
      <main className="round-intro__container">
      
        <h1 className="round-intro__title">{roundsCount > 1 ? introText.multiRoundTitle + ' ' + (currentRoundIndex + 1) : introText.singleRoundTitle }</h1>
        <div className="round-intro__description">{getDescriptionText()}</div>

        <div className="round-intro__teams">
          {game.teams.map((team, i) => (
            <React.Fragment key={i}>

              <TeamCard team={team} active />

              { i === 0 ? 
                <div className="round-intro__vs">VS</div>
              : '' }

            </React.Fragment>
          ))}
        </div>

        <SelectedCategories categories={game.categories}/>
      
        <CtaButton onClick={() => setRoundStarted(true)}>{introText.ctaButton}</CtaButton>

      </main>

    </div>
  )
}